;(function (angular, CodeMirror, _) {
  'use strict'

  angular
    .module('kilo.routes.preferences')
    .controller('DisplayTemplateController', DisplayTemplateController)

  DisplayTemplateController.$inject = [
    // Angular
    '$uibModalInstance',
    '$scope',

    // Managers
    'DefaultQuoteTemplateManager',
    'DefaultInvoiceTemplateManager',
    'DefaultCreditNoteTemplateManager',

    // Resolve
    'type', 'action', 'template',
    'availableQuoteTemplates',
    'availableInvoiceTemplates',
    'availableSituationInvoiceTemplates',
    'availableCreditNoteTemplates'

  ]

  function DisplayTemplateController (
    // Angular
    $uibModalInstance,
    $scope,

    // Managers
    DefaultQuoteTemplateManager,
    DefaultInvoiceTemplateManager,
    DefaultCreditNoteTemplateManager,

    // Resolve
    type, action, template,
    availableQuoteTemplates,
    availableInvoiceTemplates,
    availableSituationInvoiceTemplates,
    availableCreditNoteTemplates

  ) {
    var self = this
    var CM

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        jsonEditorOptions: {
          mode: 'tree'
        },
        type: type,
        action: action,
        template: template,
        availableQuoteTemplates: availableQuoteTemplates,
        availableInvoiceTemplates: availableInvoiceTemplates,
        availableSituationInvoiceTemplates: availableSituationInvoiceTemplates,
        availableCreditNoteTemplates: availableCreditNoteTemplates,

        // Methods
        cancel: cancel,
        isRendered: isRendered,
        success: success,
        addOption: addOption,
        removeOption: removeOption,
        importFromExisting: importFromExisting
      })

      init()

      initCM()
    }

    function init () {
      self.newOption = {
        key: '',
        value: ''
      }
      if (self.type === 'devis') {
        self.label = 'de devis'
        DefaultQuoteTemplateManager.get().then(function (d) {
          self.availableQuoteTemplates = self.availableQuoteTemplates || []
          if (d.data[0]) self.availableQuoteTemplates.push(d.data[0])
        })
      } else if (self.type === 'facture') {
        self.label = 'de facture'
        DefaultInvoiceTemplateManager.get().then(function (d) {
          self.availableInvoiceTemplates = self.availableInvoiceTemplates || []
          if (d.data[0]) self.availableInvoiceTemplates.push(d.data[0])
        })
      } else if (self.type === 'situation') {
        self.label = 'de facture de situation'
        DefaultInvoiceTemplateManager.get().then(function (d) {
          self.availableSituationInvoiceTemplates = self.availableSituationInvoiceTemplates || []
          if (d.data) {
            var defaultSituationTemplates = _.filter(d.data, function (elt) {
              return elt.isSituation === true
            })
            self.availableSituationInvoiceTemplates.push.apply(self.availableSituationInvoiceTemplates, defaultSituationTemplates)
          }
        })
      } else {
        self.label = "d'avoir"
        DefaultCreditNoteTemplateManager.get().then(function (d) {
          self.availableCreditNoteTemplates = self.availableCreditNoteTemplates || []
          if (d.data[0]) self.availableCreditNoteTemplates.push(d.data[0])
        })
      }
    }

    function initCM () {
      angular.element(document).ready(function () {
        CM = CodeMirror.fromTextArea(document.querySelector('#codeMirror'), {
          value: self.template.content,
          mode: { name: 'handlebars', base: 'text/html' },
          theme: 'monokai',
          tabSize: '2',
          showCursorWhenSelecting: true,
          lineNumbers: true,
          lint: true,
          gutters: ['Codemirror-lint-markers'],
          extraKeys: {
            'Ctrl-Space': 'autocomplete'
          }
        })
      })
    }

    function isRendered () {
      if (self.type === 'devis') {
        return !!self.availableQuoteTemplates.length
      } else if (self.type === 'facture') {
        return !!self.availableInvoiceTemplates.length
      } else if (self.type === 'situation') {
        return !!self.availableSituationInvoiceTemplates.length
      } else {
        return !!self.availableCreditNoteTemplates.length
      }
    }

    function updateTemplate (data) {
      if (data) {
        self.template.content = angular.copy(data.content)
        self.template.options = data.options ? angular.copy(data.options) : []
        CM.clearHistory()
        CM.setValue(self.template.content)
      }
    }

    function importFromExisting (template) {
      if (template) {
        updateTemplate(template)
      }
    }

    function addOption () {
      self.template.options = self.template.options || []
      self.template.options.unshift(angular.copy(self.newOption))
      self.newOption = { key: '', value: '' }
    }

    function removeOption (index) {
      self.template.options = self.template.options || []
      self.template.options.splice(index, 1)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    function success () {
      self.template.content = CM.getValue()
      $uibModalInstance.close(self.template)
    }
  }
})(window.angular, window.CodeMirror, window._)
